export var WalletTransactionType;
(function (WalletTransactionType) {
    WalletTransactionType["TOP_UP"] = "TOP_UP";
    WalletTransactionType["REFUND"] = "REFUND";
    WalletTransactionType["USAGE"] = "USAGE";
    WalletTransactionType["TOPUP_TRIAL"] = "TOPUP_TRIAL";
})(WalletTransactionType || (WalletTransactionType = {}));
//# sourceMappingURL=walletTransaction.js.map